<!--suppress ALL -->
<template>
  <div id="app">
    <router-view v-if="isRouterAlive"/>
  </div>
</template>

<script>
export default {
  name: 'App',
  provide() {
    return {
      reload: this.reload
    };
  },
  data() {
    return {
      isRouterAlive: true
    };
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function nextTick() {
        this.isRouterAlive = true;
      });
    }
  }
};
</script>
<style scoped>
#app {
  height: 100%;
}
</style>




// WEBPACK FOOTER //
// src/App.vue